import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'

// @ts-ignore - styled-components v4 has circular reference type issue with React 18
export const GlobalStyle = createGlobalStyle`
  ${normalize}
  html, body {
    height: 100%;
    width: 100%;
    overflow: auto;
  }

  body {
    font-size: 16px;
    background-color: #f7f7f7;
    font-family: 'Roboto', sans-serif;
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-overflow-scrolling: touch;

    * {
      box-sizing: border-box;
      -webkit-tap-highlight-color: transparent;
    }
  }
`
// .react-date-picker--disabled {
//   background-color: #e2e4e6!important;
// }